// repo/primary-care-connect/frontend/src/pages/Portal/CommunityNavigator/CaseDetail/components/GeneratedSummaryPanel.tsx

import type { GeneratedIntakeSummary } from "../types";
import TextList from "./TextList";

type GeneratedSummaryPanelProps = {
  summary: GeneratedIntakeSummary;
};

export default function GeneratedSummaryPanel({
  summary,
}: GeneratedSummaryPanelProps) {
  return (
    <div className="cn-case-detail-intake-grid">
      <article className="cn-case-detail-intake-panel">
        <h3>System priority</h3>
        <p className="cn-case-detail-muted">
          Calculated priority: <strong>{summary.priorityLevel}</strong>
        </p>
        <TextList
          items={summary.priorityReasons}
          emptyText="No priority reasons generated yet."
        />
      </article>

      <article className="cn-case-detail-intake-panel">
        <h3>HCC flags</h3>
        <TextList
          items={summary.hccFlags}
          emptyText="No HCC flags generated."
        />
      </article>

      <article className="cn-case-detail-intake-panel">
        <h3>Special population flags</h3>
        <TextList
          items={summary.specialPopulationFlags}
          emptyText="No special population flags generated."
        />
      </article>

      <article className="cn-case-detail-intake-panel">
        <h3>Matching signals</h3>
        <TextList
          items={summary.matchingSignals}
          emptyText="No matching signals generated yet."
        />
      </article>
    </div>
  );
}